/** @deprecated use import from `core-kit` */
export enum RoleTypes {
  Sales = "sales",
  Manager = "manager",
  Admin = "admin",
  LocationManager = "location-manager",
  PartnerAdmin = "partner-admin"
}

/** @deprecated use import from `core-kit` */
export class Role {
  id: number;
  name: string;
}

/** @deprecated use import from `core-kit` */
export enum RoleId {
  Admin = 1,
  Manager = 2,
  Sales = 3,
  LocationManager = 4,
  PartnerAdmin = 5
}
